export default "__VITE_ASSET__DB1H9J1M__"